import React, { useMemo, memo } from "react";
import type { JSX } from "react";
import { icons } from "./icons";

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  name: IconNameKey;
}

export type IconNameKey = keyof typeof icons;

const Icon: React.FC<IconProps> = ({ size = 20, name, ...otherProps }) => {
  // const iconData = icons[name];
  const iconData = useMemo(() => icons[name], [name]);

  if (!iconData) {
    // console.warn(`Icon "${name}" not found`);
    return null;
  }

  const defaultViewBox = "0 0 24 25";
  let path: string | JSX.Element;
  let viewBox: string;

  if (typeof iconData === "string") {
    path = iconData;
    viewBox = defaultViewBox;
  } else {
    path = iconData.path;
    viewBox = iconData.viewBox || defaultViewBox;
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      {typeof path === "string" ? <path d={path} /> : path}
    </svg>
  );
};

export default memo(Icon);
